export const ACTIONS = {
  TOGGLE_HIT_ANIMATION: 'TOGGLE_HIT_ANIMATION',
};

export const setHitAnimation = (showHitAnimation = false) => dispatch => {
  dispatch({
    type: ACTIONS.TOGGLE_HIT_ANIMATION,
    payload: {
      showHitAnimation,
    },
  });
};
